export default "__VITE_ASSET__82eeed5c__"